import { Box, Button, Flex, FormControl, FormErrorMessage, FormLabel, HStack, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text, useToast } from '@chakra-ui/react';

import { useFormik } from "formik";

import { useRef } from "react";
import AdminHelpers from '../../../services/admin/admin.service';



export const AdvertiseCourseModal: React.FC<any> = ({ courseId, isOpenAdvert, onCloseAdvert,advertise }: { courseId: string, isOpenAdvert :any ,onCloseAdvert:any, advertise : any}) => {
  
    const toast = useToast();

   

    const cancelRef = useRef().current;
    const formik = useFormik({
        validate: (values: any) => {
            const errors: any = {};

            if (!values.date) {
                errors.date = 'start date  is required'
            }
            if (!values.enddate) {
                errors.enddate = 'End date  is required'
            }
          
            return errors;
        },
        initialValues: {
            date: '',
            enddate: ''
           
        },
        onSubmit: async (values) => {
            const advertiseCourse: any = {
                course_id: courseId,
                start_date: values.date,
                end_date: values.enddate
            }
            try {
                const courseAdvert = await AdminHelpers.advertiseCourse(advertiseCourse);
                if (courseAdvert) {
                    onCloseAdvert()
                    toast({
                        title: "Course Advertisement",
                        description: "Course successfully advertised",
                        status: "success",
                    })

              
                }
            } catch (error) {

                toast({
                    title: "Course Advertisement",
                    description: "Something went wrong, try again later",
                    status: "error",
                })
            }
        }
    })

    return (
        <>
            <Modal
                isOpen={isOpenAdvert}
                onClose={onCloseAdvert}
                scrollBehavior="outside"
                closeOnOverlayClick={true}
                size="sm"
                isCentered
            >
                <ModalOverlay />
                <ModalContent borderRadius={5} px={3}>
                    <ModalHeader>
                        <Flex justifyContent='center'>
                            <Box>
                                <Flex justifyContent='center'>
                                    <Text mx='auto' color="#353535" fontSize="22px" fontWeight='800'>
                                        Advertise Course
                                    </Text>
                                </Flex>
                            </Box>
                        </Flex>

                    </ModalHeader>
                    <ModalCloseButton size="sm" />

                    <ModalBody>
                        <Box mt={4}>

                            <form onSubmit={formik.handleSubmit} >

                                <FormControl mb='26px' isInvalid={(formik.errors.date && formik.touched.date) ? true : false}>
                                    <FormLabel fontWeight="700" color="#616161" fontSize='14px'>Advertisement Start Date *</FormLabel>
                                    <Input bg="inputText.500" type='date' placeholder="Select date" value={formik.values.date} name="date" onChange={formik.handleChange} fontSize={12} />

                                    <FormErrorMessage fontSize={12} >{formik.errors.date}</FormErrorMessage>
                                </FormControl>
                                <FormControl mb='26px' isInvalid={(formik.errors.enddate && formik.touched.enddate) ? true : false}>
                                    <FormLabel fontWeight="700" color="#616161" fontSize='14px'>Advertisement End Date *</FormLabel>
                                    <Input bg="inputText.500" type='date' placeholder="Select date" value={formik.values.enddate} name="enddate" onChange={formik.handleChange} fontSize={12} />

                                    <FormErrorMessage fontSize={12} >{formik.errors.enddate}</FormErrorMessage>
                                </FormControl>


                                <Flex mt={12} justifyContent="end">
                                    <HStack>
                                        <Button colorScheme="red" type="submit"
                                            size="sm" px={6} fontSize={12} >CONFIRM</Button>
                                    </HStack>
                                </Flex>
                            </form>

                        </Box>


                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
}

